import { watch } from 'vue'
import Hotjar from '@hotjar/browser'

type ConsentPreferences = {
  necessary: boolean
  marketing: boolean
  updatedAt: string
}

export default defineNuxtPlugin(() => {
  const siteId = 6636117
  const hotjarVersion = 6

  const consent = useCookie<ConsentPreferences | null>('kudo_cookie_consent', {
    maxAge: 60 * 60 * 24 * 365,
    path: '/',
    sameSite: 'lax'
  })

  let initialized = false
  const tryInit = () => {
    if (initialized) {
      return
    }
    if (!consent.value?.necessary) {
      return
    }
    Hotjar.init(siteId, hotjarVersion)
    initialized = true
  }

  // Initialize if consent already given, otherwise wait for user action
  tryInit()
  watch(consent, tryInit, { deep: true })
})
